(() => {
  const ROW_LIMIT = 3;

  function getRows(inner) {
    const tags = Array.from(inner.querySelectorAll(':scope > a'));
    if (!tags.length) return [];

    const innerTop = inner.getBoundingClientRect().top + window.scrollY;
    const rows = [];

    tags.forEach((tag) => {
      const top = Math.round(tag.getBoundingClientRect().top + window.scrollY - innerTop);
      const bottom = Math.round(tag.getBoundingClientRect().bottom + window.scrollY - innerTop);
      const last = rows[rows.length - 1];

      if (!last || Math.abs(top - last.top) > 2) {
        rows.push({ top, bottom });
      } else {
        last.bottom = Math.max(last.bottom, bottom);
      }
    });

    return rows;
  }

  function measureCollapsedHeight(wrap, inner) {
    const prevInline = inner.style.maxHeight;
    const wasCollapsed = wrap.classList.contains('is-collapsed');

    wrap.classList.remove('is-collapsed');
    inner.style.maxHeight = 'none';

    const rows = getRows(inner);
    const collapsedHeight = rows.length
      ? rows[Math.min(ROW_LIMIT, rows.length) - 1].bottom
      : 0;
    const needsToggle = rows.length > ROW_LIMIT;

    if (wasCollapsed) wrap.classList.add('is-collapsed');
    inner.style.maxHeight = prevInline;

    return { collapsedHeight, needsToggle };
  }

  function setExpanded(wrap, inner, expanded) {
    const toggle = wrap.querySelector('[data-tag-lists-toggle]');
    const moreLabel = wrap.querySelector('[data-tag-lists-more]');
    const lessLabel = wrap.querySelector('[data-tag-lists-less]');
    if (!toggle) return;

    wrap.classList.toggle('is-collapsed', !expanded);
    wrap.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (expanded) {
      inner.style.maxHeight = 'none';
    } else {
      const height = wrap.style.getPropertyValue('--tag-lists-collapsed-height');
      if (height) inner.style.maxHeight = height;
    }

    if (moreLabel) moreLabel.hidden = expanded;
    if (lessLabel) lessLabel.hidden = !expanded;
  }

  function initTagLists(root = document) {
    root.querySelectorAll('[data-tag-lists]').forEach((wrap) => {
      const inner = wrap.querySelector('[data-tag-lists-inner]');
      const toggle = wrap.querySelector('[data-tag-lists-toggle]');
      if (!inner || !toggle) return;

      const applyMeasure = () => {
        const { collapsedHeight, needsToggle } = measureCollapsedHeight(wrap, inner);

        wrap.style.setProperty('--tag-lists-collapsed-height', `${collapsedHeight}px`);
        toggle.hidden = !needsToggle;

        if (!needsToggle) {
          setExpanded(wrap, inner, true);
          return;
        }

        const expanded = wrap.classList.contains('is-expanded');
        setExpanded(wrap, inner, expanded);
      };

      if (wrap.dataset.tagListsReady !== 'true') {
        toggle.addEventListener('click', () => {
          const expanded = !wrap.classList.contains('is-expanded');
          setExpanded(wrap, inner, expanded);
        });

        window.addEventListener('resize', () => {
          const keepExpanded = wrap.classList.contains('is-expanded');
          applyMeasure();
          if (keepExpanded) setExpanded(wrap, inner, true);
        });

        wrap.dataset.tagListsReady = 'true';
      }

      requestAnimationFrame(applyMeasure);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initTagLists());
  document.addEventListener('shopify:section:load', (event) => initTagLists(event.target));

  if (document.readyState !== 'loading') initTagLists();
})();
